import * as React from 'react'
import { Card, Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { ScanButton } from './ScanButton'
import { SortDecision } from './types'

interface Props {
  value: string
  onChange: (value: string) => void
  onSearch: (query: string) => void
  loading?: boolean
  loadingSort?: boolean
  inputquery: string
  sortDecision: SortDecision
  description?: string
}

const AmazonBookSearchInput = React.forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, onSearch, loading = false, loadingSort = false, inputquery, sortDecision, description }, ref) => {
    const handleKeyPress = React.useCallback(
      (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !loading) {
          onSearch(value)
        }
      },
      [value, onSearch, loading]
    )

    const defaultDescription = 'Scan/enter ISBN barcode or search by title'

    return (
      <Card className="amazon-book-search-input-card">
        <p className="amazon-book-search-input-description">{description || defaultDescription}</p>

        <div className="amazon-book-search-input-wrapper">
          <div className="amazon-book-search-input-container">
            <Icon icon={IconNames.BARCODE} iconSize={24} color="#5C7080" />
            <input
              ref={ref}
              type="text"
              value={value}
              onChange={e => onChange(e.target.value)}
              onKeyPress={handleKeyPress}
              className="amazon-book-search-input"
              placeholder="Scan ISBN barcode"
              disabled={loading}
            />
          </div>
        </div>

        <div className={`amazon-book-search-value ${inputquery ? 'has-content' : ''}`}>
          <p>{inputquery}</p>
        </div>

        <ScanButton variant={sortDecision} loading={loading || loadingSort} />
      </Card>
    )
  }
)

AmazonBookSearchInput.displayName = 'AmazonBookSearchInput'

export default AmazonBookSearchInput
